import { lightbox } from '../utils/lightbox.js';
import { loadCarousel } from '../utils/carousel.js';
import { faqAccordion } from '../utils/faq.js';
import sal from 'sal.js/dist/sal.js';
import 'jquery';
import '../utils/slick.js';

document.addEventListener('DOMContentLoaded', function (e) {
  const el = document.querySelector('#annual-toggle');

  const pricingCards = document.querySelector('.pricing-cards');
  if (el) {
    el.onclick = function () {
      el.classList.toggle('active');
      pricingCards.classList.toggle('annual');
    };
  }

  lightbox();
  loadCarousel();
  faqAccordion();
});

sal({
  threshold: 0.1
});

jQuery(function () {
  var table = jQuery('.pricing-plans table');
  var position = jQuery(window).scrollTop();

  jQuery(window).on('scroll', function () {
    var scroll = jQuery(window).scrollTop();
    if (scroll > position) {
      // Scrolling Down
      table.removeClass('topSpace');
    } else {
      // Scrolling Up
      table.addClass('topSpace');
    }
    position = scroll;
  });

  jQuery(window).on('load resize orientationchange', function () {
    var carousel = jQuery('.pricing-cards .cards');
    if (jQuery(window).width() > 768) {
      if (carousel.hasClass('slick-initialized')) {
        carousel.slick('unslick');
      }
    } else {
      if (!carousel.hasClass('slick-initialized')) {
        carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          dots: true,
          nextArrow: '<div class="slick-arrow slick-arrow-right"></div>',
          prevArrow: '<div class="slick-arrow slick-arrow-left"></div>'
        });
        var card = jQuery('.pricing-cards .cards .card-inner');
        card.removeAttr('data-sal data-sal-duration data-sal-delay');
      }
    }
  });

  var carousel = jQuery('.section-reviews .card-list');
  carousel.slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  jQuery('.section-reviews .social-prev').on('click', function (e) {
    jQuery('.section-reviews .slick-slider').slick('slickPrev');
  });

  jQuery('.section-reviews .social-next').on('click', function (e) {
    jQuery('.section-reviews .slick-slider').slick('slickNext');
  });

  var testimonials = jQuery('.section-testimonials .card-list');
  testimonials.slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  jQuery('.section-testimonials .social-prev').on('click', function (e) {
    jQuery('.section-testimonials .slick-slider').slick('slickPrev');
  });

  jQuery('.section-testimonials .social-next').on('click', function (e) {
    jQuery('.section-testimonials .slick-slider').slick('slickNext');
  });

  var cta = jQuery('.pricing-cta .cta-button.desktop a');
  cta.on('click', function (e) {
    e.preventDefault();
    var href = jQuery(this).attr('href');
    jQuery('html, body').animate(
      {
        scrollTop: jQuery(href).offset().top
      },
      'slow'
    );
  });

  $(document).ready(function () {
    // Function to show the appropriate pricing div based on country code
    function displayPricing(browserLang) {
      const pricingDiv = $('.currency');

      const currencyElements = document.querySelectorAll('.currency');
      //const currencyusElements = document.querySelectorAll('.currency-us');
      const currencydollarElements =
        document.querySelectorAll('.currency-dollar');
      const currencyeuroElements = document.querySelectorAll('.currency-euro');
      const currencypriceElements =
        document.querySelectorAll('.currency-price');
      // Check for language and region
      const langParts = browserLang.split('-');
      const primaryLang = langParts[0];
      const region = langParts[1];
      //console.log(browserLang);

      /*if (browserLang === 'en-us' || browserLang === 'en') {
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.dollar;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        /*currencyusElements.forEach((element) => {
          element.innerHTML = '';
        });*/
      /*currencyeuroElements.forEach((element) => {
          element.innerHTML = '';
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
      } else*/
      if (
        [
          'at',
          'ax',
          'be',
          'gp',
          'gf',
          'hr',
          'cy',
          'ee',
          'fi',
          'fr',
          'de',
          'gr',
          'ie',
          'ic',
          'it',
          'lv',
          'lt',
          'lu',
          'mq',
          'mt',
          'nl',
          'pt',
          're',
          'sk',
          'si',
          'es',
          'mc',
          'ad',
          'sm',
          'uk',
          'va',
          'yt'
        ].includes(primaryLang) ||
        (primaryLang === 'es' && region === 'es') ||
        (primaryLang === 'pt' && region === 'pt') ||
        (primaryLang === 'en' && region === 'ie')
      ) {
        //['fr', 'de', 'en-gb', 'it', 'nl', 'be', 'lu', 'ie', 'cz', 'pl', 'ro', 'hu', 'se', 'at', 'bg', 'dk', 'fi', 'sk', 'no', 'gr', 'hr', 'si', 'lt', 'lv', 'ee', 'cy', 'mt', 'is', 'li', 'mc', 'ad', 'sm', 'va']
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.euro;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        /*currencyusElements.forEach((element) => {
          element.innerHTML = '';
        });*/
        currencyeuroElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = '';
        });
      } else {
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.dollar;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        currencyeuroElements.forEach((element) => {
          element.innerHTML = '';
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
      }
      /*else {
        currencyElements.forEach((element) => {
          element.innerHTML = element.dataset.usdollar;
        });
        currencypriceElements.forEach((element) => {
          element.innerHTML = element.dataset.price;
        });
        /*currencyusElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });*/
      /*currencyeuroElements.forEach((element) => {
          element.innerHTML = '';
        });
        currencydollarElements.forEach((element) => {
          element.innerHTML = element.dataset.currency;
        });
      }*/
    }

    // Get browser language
    //const browserLang = (navigator.language || navigator.userLanguage).toLowerCase();

    // Determine pricing based on browser language and region
    //displayPricing(browserLang);

    async function determineLangUser() {
      let langUser;
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        langUser = data.country.toLowerCase();
      } catch (error) {
        //console.error("GeoIP lookup failed, falling back", error);
        langUser = navigator.language.toLowerCase();
      }

      //console.log('Language or Country Code:', langUser);
      displayPricing(langUser);
    }

    determineLangUser();
  });
});
